import { NavItem } from 'react-bootstrap';

interface IExtendedNavItemProps extends NavItem.NavItemProps {
    component: JSX.Element;
}

const NavItemReplacement = (props: IExtendedNavItemProps) => props.component;

export default NavItemReplacement;
